import { Component, inject, OnInit, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Data } from '../../core/services/data';
import { TeamMember } from '../../core/models/team-member';

@Component({
  selector: 'app-kontakt',
  imports: [CommonModule],
  templateUrl: './kontakt.html',
  styleUrl: './kontakt.css'
})
export class Kontakt implements OnInit {
  private dataService = inject(Data);

  teamMembers = signal<TeamMember[]>([]);
  isLoading = signal<boolean>(false);
  errorMessage = signal<string>('');

  ngOnInit() {
    this.loadTeam();
  }

  loadTeam() {
    this.isLoading.set(true);
    this.dataService.getTeam().subscribe({
      next: (team) => {
        this.teamMembers.set(team);
        this.isLoading.set(false);
      },
      error: (error) => {
        this.errorMessage.set('Fehler beim Laden der Teamdaten');
        this.isLoading.set(false);
        console.error('Error loading team:', error);
      }
    });
  }

  getAvatarUrl(member: TeamMember): string {
    // If using dummy_ava.png, generate a nice placeholder with initials
    if (member.ImageFile === 'dummy_ava.png') {
      const initials = member.Name.split(' ')
        .map(n => n[0])
        .join('')
        .substring(0, 2)
        .toUpperCase();
      return `https://ui-avatars.com/api/?name=${encodeURIComponent(member.Name)}&size=200&background=3b82f6&color=fff&bold=true&format=svg`;
    }
    return `images/${member.ImageFile}`;
  }
}
